import { FC, useContext } from 'react';

import { Separator } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { formatPeople, getFormattedDate } from '../../../utils';
import s from './CustomTooltip.module.scss';

interface ITooltipProps {
  data: {
    date: string;
    clients: number;
    guests: number;
    total: number;
    newClients: number;
  };
}
export const CustomTooltip: FC<ITooltipProps> = ({ data }) => {
  const { t } = useContext(LocalizationContext);
  if (!data) {
    return null;
  }

  const { date, total, guests, clients, newClients } = data;

  return (
    <div className={s.container}>
      <div className={s.header}>{getFormattedDate('D MMM, dd')(date)}</div>

      <Separator />

      <div className={s.row}>
        <span className={s.title}>{t('clients')}</span>
        {formatPeople(clients, t)}
      </div>
      <div className={s.row}>
        <span className={s.title}>{t('guests')}</span>
        {formatPeople(guests, t)}
      </div>
      <div className={s.row}>
        <span className={s.title}>{t('total')}</span>
        {formatPeople(total, t)}
      </div>

      <Separator />

      <div className={s.row}>
        <span className={s.title}>{t('visitors.types.new')}</span>
        {formatPeople(newClients, t)}
      </div>
    </div>
  );
};
